<div class="chart-print-area" style="background-color: white">
  <div>
    <mat-toolbar>
      <mat-toolbar-row>
        <span>{{ chartTitle }}</span>
        <span class="example-spacer"></span>
        <ng-container *ngIf="showControls$ | async">
          <span style="font-weight: 400">
            <button
              mat-icon-button
              (click)="onDownloadImageClick()"
              style="width: 24px"
            >
              <svg-icon src="assets/svg/download.svg"></svg-icon>
            </button>
            <span style="vertical-align: middle">{{
              'Charting.DownloadImage' | translate
            }}</span>
          </span>
          <button
            mat-icon-button
            (click)="onCloseClick()"
            style="width: 24px"
            area-label="close button"
          >
            <svg-icon src="assets/svg/x.svg"></svg-icon>
          </button>
        </ng-container>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <span
          >{{ subheaderVM?.userName }} ({{ subheaderVM?.profileName }} )
          {{ subheaderVM?.orgName }}</span
        >
        <span class="example-spacer"></span>
        <span>{{ subheaderVM?.regionName }} {{ subheaderVM?.dateRange }}</span>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>

  <div class="chart-content">
    <div fxLayout="{{ legendOrientation }}" style="width: 100%">
      <ng-container *ngIf="isLoaded$ | async">
        <tap-chart
          [chartConfig]="chartConfig"
          [chartData]="chartData"
          [height]="chartConfig.chartHeight"
          fxFlex
          (axisLabelRender)="onAxisLabelRender($event)"
          (pointRender)="onPointRender($event)"
          (tooltipRender)="onTooltipRender($event)"
          (legendClick)="onLegendClick($event)"
        ></tap-chart>
        <ng-container  *ngIf="this?.chartData?.length ?? 0 !== 0 && chartDefaultLegendDisplay == false ; else noLegend">
          <div
            style="
              background-color: hsl(0deg 0% 100%);
              padding: 20px;
              align-items: center;
              justify-content: center;
              display: flex;
              width: fit-content;
            "
          >
            <ng-content *ngTemplateOutlet="chartLegend"></ng-content>
            <ng-template #noLegend></ng-template>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
